import React, { forwardRef, useImperativeHandle, useState } from "react";
import "../../../../assets/scss/components/clientarea/serviceRequest/incomeDeclaration.scss";
import TocDropdown from "../../../generic/tocDropdown";
import InputField from "../../../generic/inputField";
import Checkbox from "../../../generic/checkbox";
import {
  CreateServiceRequest,
  GetDepositoryDetails,
  getDPID,
  GetExistingIncomeRange,
  GetNewIncomeRange,
  ServiceClientValidation,
} from "../../../service/serviceRequest/srApiService";
import { useQuery } from "../../../service/urlHelper";
import { integerExp } from "../../../utils/regex";
import { config } from "../../../../config/domain";
import { useHistory } from "react-router-dom";
import Loader from "../../../generic/loader";

// interface IHome {}
export const IncomeDeclaration = forwardRef((props: any, ref: any) => {
  const source = useQuery().get("source");
  const history = useHistory();
  const [existingIncomeSR, setExistingIncomeSR] = useState<any>();
  const [existingIncomeDetail, setExistingIncome] = useState<any>();
  const [newIncomeDetails, setNewIncomeDetails] = useState<any>();
  const [newIncome, setNewIncome] = useState<any>();
  const [newIncomeRange, setNewIncomeRange] = useState<any>();
  const [netWorthError, setNetworthErr] = useState<any>();
  const [netWorthErrorColor, setNetWorthErrorColor] =
    useState<any>("warm-grey-eight");
  const [netWorth, setNetworthValue] = useState<any>();
  const [newtWorthBoolean, setNewworthBoolean] = useState<any>();
  const [newtWorthBoolean1, setNewworthBoolean1] = useState<any>();
  const [dpId, setDpId] = useState<any>();
  const [childSr, setChildSr] = useState(props.childSr ? props.childSr : false);
  //const [loader, setLoader] = useState(false);
  const [serviceReqListArr, setServiceReqListArr] = useState<any>();
  let storedList = window.sessionStorage.getItem("serviceReqList");
  React.useEffect(() => {
    setServiceReqListArr(storedList ? JSON.parse(storedList) : []);
  }, [storedList]);
  async function getExistingIncomeDeclaration() {
    props.setLoader(true);
    try {
      const resp = await GetExistingIncomeRange();
      if (resp && resp.result) {
        setExistingIncome(resp.result[0]);
        props.setLoader(false);
      } else {
        incomeDeclarationApiError();
      }
    } catch (error) {
      incomeDeclarationApiError();
    }
  }
  async function getNewIncomeRange() {
    props.setLoader(true);
    try {
      const resp = await GetNewIncomeRange();
      if (resp) {
        const list = resp.map((respObj: any) => {
          return {
            value: respObj.ValueItem,
            display: respObj.DisplayItem,
          };
        });
        setNewIncomeDetails(list);
        props.setLoader(false);
      } else {
        incomeDeclarationApiError();
      }
    } catch (error) {
      incomeDeclarationApiError();
    }
  }
  React.useEffect(() => {
    if (!newIncomeRange) {
      props.enableSubmit(false);
      if (props.childSr) {
        props.childSrB(false);
      }
    }
    if (newIncomeRange) {
      if (newIncomeRange.value === "0") {
        props.enableSubmit(false);
        if (props.childSr) {
          props.childSrB(false);
        }
      } else {
        props.enableSubmit(true);
        if (props.childSr) {
          props.childSrB(true);
        }
      }
    }
  }, [newIncomeRange]);
  React.useEffect(() => {
    if (!netWorth) {
      if (netWorth === 0) {
        props.enableSubmit(false);
        if (props.childSr) {
          props.childSrB(false);
        }
      } else {
        setNetworthErr("Min. Amount Rs. 1000");
        if (!(newIncomeRange && newtWorthBoolean && newtWorthBoolean1)) {
          props.enableSubmit(false);
          if (props.childSr) {
            props.childSrB(false);
          }
        } else {
          props.enableSubmit(true);
          if (props.childSr) {
            props.childSrB(true);
          }
        }
      }
    }
    if (netWorth) {
      if (netWorth < 1000) {
        props.enableSubmit(false);
        if (props.childSr) {
          props.childSrB(false);
        }
      } else {
        if (!(newIncomeRange && newtWorthBoolean && newtWorthBoolean1)) {
          if (newIncomeRange && newIncomeRange.value !== "0") {
            props.enableSubmit(true);
            if (props.childSr) {
              props.childSrB(true);
            }
          } else {
            props.enableSubmit(false);
            if (props.childSr) {
              props.childSrB(false);
            }
          }
        } else {
          props.enableSubmit(true);
          if (props.childSr) {
            props.childSrB(true);
          }
        }
      }
    }
  }, [netWorth]);
  React.useEffect(() => {
    console.log(newIncomeRange);
    if (!(newIncomeRange && newtWorthBoolean && newtWorthBoolean1)) {
      props.enableSubmit(false);
      if (props.childSr) {
        props.childSrB(false);
      }
    } else {
      if (netWorth) {
        if (netWorth < 1000) {
          props.enableSubmit(false);
          if (props.childSr) {
            props.childSrB(false);
          }
        } else {
          props.enableSubmit(true);
          if (props.childSr) {
            props.childSrB(true);
          }
        }
      } else {
        if (netWorth === 0) {
          props.enableSubmit(false);
          if (props.childSr) {
            props.childSrB(false);
          }
        } else {
          props.enableSubmit(true);
          if (props.childSr) {
            props.childSrB(true);
          }
        }
      }
    }
  }, [newIncomeRange, newtWorthBoolean, newtWorthBoolean1]);
  function incomeDeclarationApiError() {
    props.setLoader(false);
    if (!childSr)
      props.onSubmit("incomeDeclarationApiError", {
        content:
          "There was some problem in raising service request. Please try again later.",
        headerText: "New Service Request",
      });
  }
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("incomeDeclarationApiError", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  const getDepositoryDet = async () => {
    try {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        setDpId(resp.dPIdField + resp.dPAccountNumberField);
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        setDpId(0);
        return "None";
      }
    } catch (error) {
      incomeDeclarationApiError();
    }
  };
  async function submitRequest() {
    try {
      props.setLoader(true);
      const reqObj = {
        requestType: "Income Declaration",
        dpID: dpId,
        income_range: newIncomeRange.display,
        net_worth_value: netWorth,
        gross_annual_income_range_code: newIncomeRange.value,
      };
      let resp = await CreateServiceRequest(reqObj);
      if (
        typeof resp === "string" &&
        resp.includes("Previous Request already open for this account-")
      ) {
        openExistSrPopup();
        return;
      } else {
        if (resp.Message) {
          props.setLoader(false);
          props.onSubmit("incomeDeclaration", {
            content: resp.Message,
            headerText: "We've Recieve Your Request",
            popupType: "Success",
          });
        } else {
          incomeDeclarationApiError();
        }
      }
    } catch (error) {
      incomeDeclarationApiError();
    }
  }
  async function checkExistingIncomeSR() {
    setExistingIncomeSR("");
    props.setLoader(false);
    props.showFooter(true);
  }
  function setIncomeRange(document: any) {
    if (document && document !== "0") {
      setNewIncome(document);
      setNewIncomeRange(newIncomeDetails[document]);
      setNewworthBoolean(true);
      setNewworthBoolean1(true);
    } else {
      setNewIncome(undefined);
      setNewIncomeRange(undefined);
      setNewworthBoolean(false);
      setNewworthBoolean1(false);
    }
  }
  function setNetworth(value: any) {
    if (!value) {
      setNetworthValue(undefined);
      setNetworthErr("Min. Amount Rs. 1000");
      setNetWorthErrorColor("warm-grey-eight");
    } else if (value && parseInt(value) < 1000) {
      if (!integerExp.test(value)) {
        setNetworthValue("");
        setNetworthErr("Invalid Input Amount");
        setNetWorthErrorColor("red");
      } else {
        setNetworthValue(parseInt(value));
        setNetworthErr("Invalid Input Min. Amount Rs. 1000");
        setNetWorthErrorColor("red");
      }
    } else if (value && parseInt(value) >= 1000) {
      if (!integerExp.test(value)) {
        setNetworthValue("");
        setNetworthErr("Invalid Input Amount");
        setNetWorthErrorColor("red");
      } else {
        setNetworthValue(parseInt(value));
        setNetworthErr("");
      }
    }
  }
  function setConfirmation() {
    if (newtWorthBoolean) {
      setNewworthBoolean(false);
    } else {
      setNewworthBoolean(true);
    }
  }
  function setConfirmation1() {
    if (newtWorthBoolean1) {
      setNewworthBoolean1(false);
    } else {
      setNewworthBoolean1(true);
    }
  }

  React.useEffect(() => {
    if (!childSr) checkExistingIncomeSR();
    getExistingIncomeDeclaration();
    getNewIncomeRange();
    getDepositoryDet();

    return () => {};
  }, []);

  useImperativeHandle(ref, () => ({
    async getSubmitData() {
      const reqObj = {
        requestType: "Income Declaration",
        dpID: await getDepositoryDet(),
        income_range: newIncomeRange?.display,
        net_worth_value: netWorth,
        gross_annual_income_range_code: newIncomeRange?.value,
      };
      // console.log(reqObj);
      return reqObj;
    },
    submitData() {
      submitRequest();
    },
  }));
  function redirection(): void {
    history.goBack();
    history.goBack();
  }
  const isAccClouserOpen =
    serviceReqListArr?.length &&
    serviceReqListArr.find(
      (item: any) =>
        item.RequestType === "Online Closure" &&
        (item.RequestStatus === "EsignSubmitted" ||
          item.RequestStatus === "Assigned" ||
          item.RequestStatus === "Open" ||
          item.RequestStatus === "PendingForEsign")
    );

  return (
    <>
      {props.loader ? null : !props.loader && !isAccClouserOpen ? (
        <div className="incomeDeclare">
          {!childSr && !props.loader && existingIncomeSR}
          {!props.loader && !existingIncomeSR && (
            <div>
              {!childSr && (
                <div className="existing-income">
                  <label className="incomeMsg">
                    Existing Financial Details
                  </label>
                  <div className="custom--row">
                    <div className="custom-col">
                      {existingIncomeDetail && (
                        <p className="ei-text">
                          Annual Income Range (As on{" "}
                          {existingIncomeDetail.gross_annual_income_date} )
                        </p>
                      )}
                      {existingIncomeDetail && (
                        <strong className="ei-val">
                          Between {existingIncomeDetail?.annual_income_range}.
                        </strong>
                      )}
                    </div>
                    <div className="custom-col">
                      {existingIncomeDetail && (
                        <p className="ei-text">
                          Networth (As on {existingIncomeDetail?.networth_date})
                        </p>
                      )}
                      {existingIncomeDetail && (
                        <strong className="ei-val">
                          {existingIncomeDetail?.networth}
                        </strong>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="new-income custom-row">
                <label className="incomeMsg bold-text">
                  New Financial Details
                </label>
                <div className="custom--row incomeMsg--row">
                  <div className="form-field custom-col">
                    {" "}
                    <label className="input-label">Annual Income Range</label>
                    <div>
                      {newIncomeDetails && (
                        <TocDropdown
                          selectedValue={
                            newIncome ? newIncome : newIncomeDetails[0].value
                          }
                          dropdownOptions={
                            newIncomeDetails ? newIncomeDetails : []
                          }
                          onSelect={(value) => setIncomeRange(value)}
                          isSearchable={false}
                        />
                      )}
                    </div>
                  </div>
                  <div className="  custom-col">
                    {" "}
                    <label className="input-label">Networth (Optional)</label>
                    <div className="italic-placeholder">
                      {props.childSr ? (
                        <InputField
                          integer={true}
                          onChange={(value) => {
                            setNetworth(value);
                          }}
                          defaultValue={netWorth}
                          onBlur={() => {}}
                          placeholder="Enter Networth"
                          helpText={netWorthError}
                          helpTextColor={netWorthErrorColor}
                        />
                      ) : (
                        <InputField
                          integer={true}
                          onChange={(value) => {
                            setNetworth(value);
                          }}
                          onBlur={() => {}}
                          placeholder="Enter Networth"
                          errorText={netWorthError}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="checkboxWrapper">
                {newIncomeRange && (
                  <>
                    <div className="display-flex declarationWrap">
                      <Checkbox
                        checked={newtWorthBoolean}
                        name="consent"
                        onChange={() => setConfirmation()}
                      >
                        <span className="incomeMsg regular-font declare">
                          {" "}
                          I/We hereby confirm/undertake that the
                          investments/trading done in securities market are from
                          my/our own/borrowed sources of funds and I/we confirm
                          that the funds utilized for trading activity by me/us
                          are in compliance with the rules, regulations and
                          guidelines stipulated under PMLA.
                        </span>
                      </Checkbox>{" "}
                    </div>
                  </>
                )}
                {newIncomeRange && (
                  <>
                    <div className="display-flex declarationWrap">
                      <Checkbox
                        checked={newtWorthBoolean1}
                        name="consent"
                        onChange={() => setConfirmation1()}
                      >
                        <span className="incomeMsg regular-font declare">
                          {" "}
                          I further confirm that the value of assets mentioned
                          above are my own source of Income/by way of
                          inheritance for my account with Nuvama Wealth and
                          Investment Limited (applicable for Demat account
                          holders).{" "}
                        </span>
                      </Checkbox>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="help-text red line-ht-standard">
          You have an ongoing account closure request. During this time, you
          cannot initiate any request.
        </p>
      )}
    </>
  );
});
